import React, { useState, useEffect } from "react";
import "antd/dist/antd.min.css";
import "../../index.css";
import LogoTransparency from "../../Images/LogoTransparency.png";
import { Auth } from "aws-amplify";
import {
  Button,
  Row,
  Col,
  Dropdown,
  Menu,
  message,
  Input,
  Modal,
  Form,
  Avatar,
  Popover
} from "antd";
import { Link, withRouter } from "react-router-dom";
import { DownOutlined, UserOutlined } from "@ant-design/icons";
import AppConfig from "../config/AppConfig";
import { getUser } from "../../Api/Apis";

const fetchMediaProfile = async (username, userObj) => {
  const entity = AppConfig["entityNames"]["registrations"];
  const keys = [
    username,
    userObj?.attributes?.email,
    userObj?.attributes?.sub,
  ].filter(Boolean);

  for (const k of keys) {
    try {
      const res = await getUser(entity, k);
      const u = res?.data?.data || res?.data || null;
      if (res?.success && u) return u;
    } catch (e) {
      console.log(e);
    }
  }
  return null;
};

const mapQuestionnaireToForm = (u) => ({
  // Section 1
  businessName: u.businessName ?? "",
  contactName: u.contactName ?? u.contactPerson ?? "",
  contactTitle: u.contactTitle ?? "",
  email: u.email ?? "",
  phone: u.phone ?? "",
  street: u.street ?? "",
  city: u.city ?? "",
  state: u.state ?? "",
  zip: u.zip ?? "",
  signedInExisting: true,
  questionnaireId: u.id,
  id: u.id,

  // Section 2
  industries: Array.isArray(u.industries)
    ? u.industries
    : u.industries
    ? [u.industries]
    : Array.isArray(u.industry)
    ? u.industry
    : u.industry
    ? [u.industry]
    : [],
  entityType: u.entityType ?? u.businessEntityType ?? "",
  counties: Array.isArray(u.service)
    ? u.service
    : u.service
    ? [u.service]
    : Array.isArray(u.area)
    ? u.area
    : u.area
    ? [u.area]
    : [],

  // Section 3
  objectivesAwareness: Array.isArray(u.objectivesAwareness)
    ? u.objectivesAwareness
    : u.objectivesAwareness
    ? [u.objectivesAwareness]
    : [],
  objectivesEngagement: Array.isArray(u.objectivesEngagement)
    ? u.objectivesEngagement
    : u.objectivesEngagement
    ? [u.objectivesEngagement]
    : [],
  objectivesAction: Array.isArray(u.objectivesAction)
    ? u.objectivesAction
    : u.objectivesAction
    ? [u.objectivesAction]
    : [],
  successMetrics: Array.isArray(u.successMetrics)
    ? u.successMetrics.map((s) => String(s).trim())
    : u.successMetrics
    ? [String(u.successMetrics).trim()]
    : [],
  startTime: u.startTime ?? u.adStartTime ?? "",

  // Section 4
  hasSpent: u.hasSpent ?? "",
  adTypes: Array.isArray(u.adTypes) ? u.adTypes : u.adTypes ? [u.adTypes] : [],
  adTypesOther: u.adTypesOther ?? "",
  adReasons: Array.isArray(u.adReasons)
    ? u.adReasons
    : u.adReasons
    ? [u.adReasons]
    : [],
  adReasonsOther: u.adReasonsOther ?? "",
  adEffectiveness: u.adEffectiveness ?? "",
  adResults: Array.isArray(u.adResults)
    ? u.adResults
    : u.adResults
    ? [u.adResults]
    : [],
  adResultsOther: u.adResultsOther ?? "",
  adFailures: Array.isArray(u.adFailures)
    ? u.adFailures
    : u.adFailures
    ? [u.adFailures]
    : [],
  adFailuresOther: u.adFailuresOther ?? "",
  adWorth: u.adWorth ?? "",
  adFrequency: u.adFrequency ?? "",

  // Section 5
  gender: Array.isArray(u.gender) ? u.gender : u.gender ? [u.gender] : [],
  household: Array.isArray(u.household)
    ? u.household
    : u.household
    ? [u.household]
    : [],
  lifeStage: Array.isArray(u.lifeStage)
    ? u.lifeStage
    : u.lifeStage
    ? [u.lifeStage]
    : [],
  ageGroups: Array.isArray(u.ageGroups ?? u.agegroup)
    ? (u.ageGroups ?? u.agegroup).map((s) =>
        String(s).replace(/-/g, "-").trim()
      )
    : u.ageGroups ?? u.agegroup
    ? [
        String(u.ageGroups ?? u.agegroup)
          .replace(/-/g, "-")
          .trim(),
      ]
    : [],
  ethnicGroups: Array.isArray(u.ethnicGroups)
    ? u.ethnicGroups
    : u.ethnicGroups
    ? [u.ethnicGroups]
    : [],
  ethnicGroupsOther: u.ethnicGroupsOther ?? "",

  // Section 6
  marketingAssets: Array.isArray(u.marketingAssets)
    ? u.marketingAssets
    : u.marketingAssets
    ? [u.marketingAssets]
    : [],
  marketingAssetsOther: u.marketingAssetsOther ?? "",
  assetsStatus: u.assetsStatus ?? "",
  lastUpdatedAssets: u.lastUpdatedAssets ?? "",
  businessHighlights: Array.isArray(u.businessHighlights)
    ? u.businessHighlights
    : u.businessHighlights
    ? [u.businessHighlights]
    : [],
  businessHighlightsOther: u.businessHighlightsOther ?? "",

  // Section 7
  competition: Array.isArray(u.competition)
    ? u.competition
    : u.competition
    ? [u.competition]
    : [],
  otherCompetition: u.otherCompetition ?? "",
  competitionImpact: Array.isArray(u.competitionImpact)
    ? u.competitionImpact
    : u.competitionImpact
    ? [u.competitionImpact]
    : [],
  otherCompetitionImpact: u.otherCompetitionImpact ?? "",
  startPromotion: !u.startPromotion
    ? ""
    : u.startPromotion.toLowerCase().includes("soon")
    ? "ASAP"
    : u.startPromotion.toLowerCase().includes("next month")
    ? "NextMonth"
    : u.startPromotion.toLowerCase().includes("1-3")
    ? "1-3Months"
    : u.startPromotion.toLowerCase().includes("more than 3") ||
      u.startPromotion.toLowerCase().includes(">3")
    ? "MoreThan3"
    : u.startPromotion.toLowerCase().includes("explor")
    ? "ExploringOptions"
    : u.startPromotion,
  budget: u.rangeGoals,

  // Section 8
  contactMethod:
    u.preferredContact === "E-Mail"
      ? "Email"
      : u.preferredContact === "Phone"
      ? "Phone"
      : u.contactMethod ?? "",
  permission: !!(u.permission ?? u.information),
});

const mapRegistrationToMediaForm = (u) => ({
  // Section 1
  businessName: u.businessName ?? "",
  contactName: u.contactPerson ?? "",
  title: u.title ?? "",
  email: u.email ?? "",
  phoneNumber: u.phoneNumber ?? "",
  address: u.address ?? "",
  city: u.city ?? "",
  stateName: u.place ?? "",
  state: u.place ?? "",
  zip: u.zip ?? "",
  businessEntityType: u.businessEntityType ?? "",
  vendorRegistration: u.vendorRegistration ?? "",
  smbCertification: u.smbCertification ?? "",
  id: u.id,

  // Section 2
  area: u.area ?? [],
  localWorkPercent: (u.localWorkPercent || "").replace(/-/g, "-").trim(),

  // Section 3
  creativeProduction: u.creativeProduction ?? [],
  digitalMarketing: u.digitalMarketing ?? [],
  advertisingChannels: u.advertisingChannels ?? [],
  publicEngagement: u.publicEngagement ?? [],
  otherServices: u.otherServices ?? "",
  creativeDevelopment: u.creativeDevelopment ?? "",
  creativeDevelopmentExplanation: u.creativeDevelopmentExplanation ?? "",

  // Section 4
  coreSpecialties: u.coreSpecialties ?? [],
  otherCoreSpecialty: u.otherCoreSpecialty ?? "",
  matchComfort: u.matchComfort ?? "",
  matchComfortExplanation: u.matchComfortExplanation ?? "",
  campaignExecution: u.campaignExecution ?? "",
  leadTime: u.leadTime ?? "",

  // Section 5
  ageGroups: Array.isArray(u.ageGroup)
    ? u.ageGroup.map((s) => String(s).replace(/-/g, "-").trim())
    : u.ageGroup
    ? [String(u.ageGroup).replace(/-/g, "-").trim()]
    : [],
  lifestyles: u.lifestyles ?? [],
  otherLifestyles: u.otherLifestyles ?? "",
  culturalGroups: u.culturalGroups ?? [],
  otherCulturalGroups: u.otherCulturalGroups ?? "",

  // Section 6
  industries: u.industry ?? [],
  topIndustries: u.topIndustries ?? [],
  proofOfWork: u.proofOfWork ?? {},
  otherIndustries: u.otherIndustries ?? "",

  // Section 7
  kpis: u.kpis ?? [],
  otherKpis: u.otherKpis ?? "",
  reportingFrequency: u.reportingFrequency ?? "",
  analyticsTools: u.analyticsTools ?? [],
  otherAnalyticsTools: u.otherAnalyticsTools ?? "",

  // Section 8
  budgetRange: ((Array.isArray(u.ranges) ? u.ranges[0] : u.ranges) || ""),
  clientsBelow10k: u.clientsBelow10k ?? "",
  clientReferences: u.clientReferences ?? "",

  signedInExisting: true,
});

const jumpToMediaSection2 = (history, profile) => {
  const prefill = mapRegistrationToMediaForm(profile);
  localStorage.setItem("MediaPrefill", JSON.stringify(prefill));
  localStorage.setItem("MediaGotoStep", "1");
  localStorage.setItem("id", String(profile.id || ""));
  history.push("/app/media-outlet-signup");
};

function Header(props) {
  const [visible, setVisible] = useState(false);
  const [role, setRole] = useState("business");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loggingIn, setLoggingIn] = useState(false);
  const [profileVisible, setProfileVisible] = useState(false);
  const [profileEmail, setProfileEmail] = useState("");
  const [oldPwd, setOldPwd] = useState("");
  const [newPwd, setNewPwd] = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [updatingPwd, setUpdatingPwd] = useState(false);
  const [canEditProfile, setCanEditProfile] = useState(true);
  const [loginId, setLoginId] = useState(localStorage.getItem("leadId") || null);


  const content = (
    <div>
      <p>-Minimum password length: 6</p>
      <p>-Required at least one uppercase letter</p>
      <p>-Required at least one lowercase letter</p>
      <p>-Required at least one number</p>
      <p>-Required at least one nonalphanumeric character</p>
    </div>
  );

  useEffect(() => {
    // try Amplify first
    Auth.currentAuthenticatedUser()
      .then((u) => {
        const e =
          u?.attributes?.email || // Cognito email
          u?.username || // fallback to username
          "";
        if (e) setProfileEmail(e);
      })
      .catch(() => {
        // fallback to localStorage profile if Amplify fails
        try {
          const profile = JSON.parse(
            localStorage.getItem("loginDetails") || "null"
          );
          const emailFromProfile =
            profile?.email || profile?.attributes?.email || "";
          if (emailFromProfile) setProfileEmail(emailFromProfile);
        } catch {}
      });
  }, [profileVisible]); // runs when modal is shown

  useEffect(() => {
    if (!loginId) return;
    // Try localStorage first
    try {
      const profile = JSON.parse(
        localStorage.getItem("loginDetails") || "null"
      );
      const emailFromProfile =
        profile?.email || profile?.attributes?.email || "";
      if (emailFromProfile) setProfileEmail(emailFromProfile);
    } catch {}
    // Then ask Amplify (best source of truth)
    Auth.currentAuthenticatedUser()
      .then((u) => {
        const e = u?.attributes?.email;
        if (e) setProfileEmail(e);
      })
      .catch(() => {});
  }, [loginId]);

  const openProfile = () => setProfileVisible(true);
  const closeProfile = () => {
    setProfileVisible(false);
    setOldPwd("");
    setNewPwd("");
    setConfirmPwd("");
  };

  const handleUpdatePassword = async () => {
    if (!oldPwd || !newPwd || !confirmPwd) {
      return message.warning("Please fill all password fields.");
    }
    if (newPwd !== confirmPwd) {
      return message.error("New password and confirmation do not match.");
    }
    if (newPwd.length < 8) {
      return message.error("New password must be at least 8 characters.");
    }
    try {
      setUpdatingPwd(true);
      const user = await Auth.currentAuthenticatedUser();
      await Auth.changePassword(user, oldPwd, newPwd);
      message.success("Password updated successfully.");
      setCanEditProfile(false);
      closeProfile();
    } catch (err) {
      console.error(err);
      message.error(err?.message || "Failed to update password.");
    } finally {
      setUpdatingPwd(false);
    }
  };

const handleLogout = async () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  try {
    await Auth.signOut();
  } catch (err) {
    console.warn("signOut failed:", err);
  } finally {
    // remove only keys related to current session
    localStorage.removeItem("user");
    localStorage.removeItem("loginDetails");
    localStorage.removeItem("userid");
    localStorage.removeItem("leadId");
    localStorage.removeItem("BusinessQuestionnaireId");
    localStorage.removeItem("MediaQuestionnaireId");
    // keep other global settings if you have any
    setLoginId(null);
    setUsername("");
    setPassword("");
    setRole(null);
    setVisible(true);
    props.history.push("/");
  }
};

  const userMenu = (
    <Menu>
      {canEditProfile && (
     <Menu.Item key="profile" onClick={openProfile}>
       Change Password
     </Menu.Item>
   )}

    {/* Sign-in options: choose business OR media */}
    <Menu.Item key="signin-business" onClick={() => showLogin("business")}>
      Business Sign-In
    </Menu.Item>

    <Menu.Item key="signin-media" onClick={() => showLogin("media")}>
      Media Outlet Sign-In
    </Menu.Item>
      <Menu.Item key="logout" onClick={handleLogout}>
        Logout
      </Menu.Item>
    </Menu>
  );

  const handleClick = () => {
    localStorage.setItem("path", JSON.stringify(""));
  };

  const showLogin = (r = "business") => {
    setRole(r);
    setVisible(true);
  };
  const hideModal = () => {
    setVisible(false);
    setUsername("");
    setPassword("");
  };

  const saveLoginSession = (role, profile) => {
    localStorage.setItem("userid", JSON.stringify(profile.id));
    localStorage.setItem("loginDetails", JSON.stringify(profile));
    localStorage.setItem("leadId", JSON.stringify(profile.id));

    if (role === "business") {
      localStorage.setItem(
        "BusinessQuestionnaireId",
        JSON.stringify(profile.id)
      );
    } else {
      localStorage.setItem("MediaQuestionnaireId", JSON.stringify(profile.id));
    }
  };
  const jumpToBusinessSection2 = (history, profile) => {
    const prefill = mapQuestionnaireToForm(profile);
    localStorage.setItem("BusinessPrefill", JSON.stringify(prefill));
    localStorage.setItem("BusinessGotoStep", "1");
    history.push("/app/business-signup");
  };

const handleSignin = async (e) => {
  e?.preventDefault?.();
  if (!username || !password) {
    message.warning("Please enter username and password.");
    return;
  }
  try {
    setLoggingIn(true);
    // sign-in with Cognito
    const user = await Auth.signIn(username, password);
    localStorage.setItem("user", JSON.stringify(user?.username || username));

    // Try to fetch profile from common places (questionnaires first, then registrations)
    let profile = null;
    let profileSource = null; // "business" or "media"

    try {
      const resQ = await getUser(AppConfig["entityNames"]["questionnaires"], user.username);
      const maybeQ = resQ?.data || resQ?.data?.data || null;
      if (resQ?.success && maybeQ) {
        profile = maybeQ;
        profileSource = "business";
      }
    } catch (e) {
      // ignore
    }

    // fallback to registrations if questionnaires didn't return a profile
    if (!profile) {
      try {
        const resR = await getUser(AppConfig["entityNames"]["registrations"], user.username);
        const maybeR = resR?.data?.data || resR?.data || null;
        if (resR?.success && maybeR) {
          profile = maybeR;
          profileSource = "media";
        }
      } catch (e) {
        // ignore
      }
    }

    // If still no profile and we have a helper fetchMediaProfile, try it
    if (!profile && role === "media") {
      profile = await fetchMediaProfile(user.username, user);
      if (profile) profileSource = "media";
    }

    if (profile) {
      // save session & update UI
      const roleName = profileSource === "media" ? "media" : "business";
      saveLoginSession(roleName, profile);
      setLoginId(String(profile.id || profile.email || user.username));
      message.success("Signed in successfully.");
      hideModal();
      // navigate to appropriate place
      if (profileSource === "media") jumpToMediaSection2(props.history, profile);
      else jumpToBusinessSection2(props.history, profile);
    } else {
      // nothing returned — fall back to role if you still want that behavior
      // but better to tell user profile not found
      message.error("Profile not found. Please sign up.");
    }
  } catch (error) {
    console.error("error signing in", error);
    message.error(error?.message || "Sign-in failed.");
  } finally {
    setLoggingIn(false);
  }
};


  return (
    <div className="site-page-header-ghost-wrapper">
      {/* <PageHeader
        ghost={false}
       
        extra={[ */}
      <Row style={{ marginTop: "15px", marginBottom: "15px" }}>
        <Col
          xxl={{ span: 10, offset: 1 }}
          xl={{ span: 6, offset: 1 }}
          lg={{ span: 6, offset: 1 }}
          md={{ span: 22, offset: 1 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
        >
          <Link to="/">
            <div style={{ float: "left" }}>
              <img
                src={LogoTransparency}
                style={{
                  width: "294px",
                  height: "44px",
                  float: "left",
                }}
                alt="uploaded"
              />
            </div>
          </Link>
        </Col>
        <Col
          xxl={{ span: 11, offset: 0 }}
          xl={{ span: 14, offset: 0 }}
          lg={{ span: 14, offset: 0 }}
          md={{ span: 10, offset: 0 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
          className="show_desktop_header"
        >
          <Link to="/">
            <Button key="1" style={{ fontWeight: "bold", border: "0px" }}>
              Home
            </Button>
          </Link>
          {/* <Button key="2" style={{ fontWeight: "bold", border: "0px" }}>
            Business
          </Button> */}
          <Link to="/app/Media">
            <Button key="3" style={{ fontWeight: "bold", border: "0px" }}>
              Marketing/Media
            </Button>
          </Link>
          <Link to="/app/About">
            <Button key="4" style={{ fontWeight: "bold", border: "0px" }}>
              About Us
            </Button>
          </Link>
          <Link to="/app/Contact">
            <Button key="5" style={{ fontWeight: "bold", border: "0px" }}>
              Contact
            </Button>
          </Link>
          {!loginId && (
            <Dropdown overlay={userMenu} trigger={["click"]}>
              <Button
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 8,
                  borderRadius: 24,
                }}
              >
                <Avatar size="small" icon={<UserOutlined />} />
                <span>Account</span>
                <DownOutlined />
              </Button>
            </Dropdown>
          )}
          {/* <Link to="/app/register"> */}
          <Link to="/app/media-outlet-signup">
            <Button
              key="1"
              onClick={handleClick}
              type="primary"
              style={{
                borderRadius: "50px",
                backgroundColor: "#165874",
                width: "200px",
                justifyContent: "center",
              }}
            >
              Join As a Media Outlet
            </Button>
          </Link>
          <div>
            {loginId && (
              <Button
                key="1"
                onClick={handleLogout}
                type="primary"
                style={{
                  borderRadius: "50px",
                  backgroundColor: "#165874",
                  width: "150px",
                  justifyContent: "center",
                }}
              >
                Logout
              </Button>
            )}
          </div>
        </Col>
        {window.location.pathname === "/" && (
          <Row>
            <Col span={12} style={{ marginLeft: "5px" }}>
              {/* <Link to="/app/register" className="show_mobile"> */}
              <Link to="/app/media-outlet-signup" className="show_mobile">
                <Button
                  key="1"
                  onClick={handleClick}
                  type="primary"
                  className="show_mobile_btn"
                >
                  Join As a Media Outlet
                </Button>
              </Link>
            </Col>

            {/* <Col span={7}>
              {!loginId && (
                <Link to="/app/Leadlogin" className="show_mobile">
                  <div style={{ padding: "2px" }}>
                    <Button
                      key="1"
                      onClick={handleClick}
                      type="primary"
                      className="show_mobile_btn"
                    >
                      My Leads
                    </Button>
                  </div>
                </Link>
              )}
            </Col> */}
          </Row>
        )}
        {window.location.pathname === "/app/Myleads" && (
          <Col span={4} className="show_mobile">
            <div>
              {loginId && (
                <Button
                  key="1"
                  onClick={handleLogout}
                  type="primary"
                  className="show_mobile_btn"
                >
                  Logout
                </Button>
              )}
            </div>
          </Col>
        )}
      </Row>
      {visible && (
        <Modal
          // title={`SIGN-IN ${
          //   role === "media" ? "(Media Outlet)" : "(Business)"
          // }`}
          title="SIGN-IN"
          visible={visible}
          onCancel={hideModal}
          destroyOnClose
          footer={
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 12,
                paddingTop: 4,
              }}
            >
              <a
                onClick={() => {
                  setVisible(false);
                  sessionStorage.setItem("backSrc", "header");
                  props.history.push({
                    pathname: "/app/ForgotPassword",
                    state: { fromHeader: true },
                  });
                }}
                style={{
                  color: "rgb(22, 88, 116)",
                  fontWeight: "bold",
                  cursor: "pointer",
                }}
              >
                Forgot password?
              </a>

              <Button type="primary" onClick={handleSignin} loading={loggingIn}>
                Log in
              </Button>
            </div>
          }
        >
          <Form layout="vertical">
            <Form.Item label="Email Address:">
              <Input
                className="input_modal"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </Form.Item>
            <Form.Item label="Password">
              <Input.Password
                className="input_password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Item>
          </Form>
        </Modal>
      )}

      <Modal
        title="My Profile"
        visible={profileVisible}
        onCancel={() => setProfileVisible(false)}
        destroyOnClose
        footer={
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 8 }}>
            <Button onClick={() => setProfileVisible(false)}>Cancel</Button>
            <Button
              type="primary"
              loading={updatingPwd}
              onClick={handleUpdatePassword}
            >
              Update Password
            </Button>
          </div>
        }
      >
        <Form layout="vertical">
          <Form.Item label="Email (for reference)">
            <Input value={profileEmail} disabled />
          </Form.Item>
          <Form.Item label="Old Password(Which is sent to your email)">
            <Input.Password
              value={oldPwd}
              onChange={(e) => setOldPwd(e.target.value)}
              placeholder="Enter current password"
            />
          </Form.Item>
          <Popover content={content} title="Password Criteria">
            <Button
              className="criteria"
              type="text"
              style={{
                color: "#39acda",
                marginLeft: "-15px",
                background: "transparent",
                border: "none",
              }}
            >
              Password Criteria
            </Button>
          </Popover>
          <Form.Item label="New Password">
            <Input.Password
              value={newPwd}
              onChange={(e) => setNewPwd(e.target.value)}
              placeholder="Enter new password"
            />
          </Form.Item>
          <Form.Item label="Confirm New Password">
            <Input.Password
              value={confirmPwd}
              onChange={(e) => setConfirmPwd(e.target.value)}
              placeholder="Re-enter new password"
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}

export default withRouter(Header);
